
import {define} from "observable:runtime";
import asset1 from "../style.css?url";

const assets = new Map([
  ["../style.css", asset1]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle} = await import("../lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, clickableCanvas, canvasTest, canvasTestReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,codeEditor,clickableCanvas,canvasTest,canvasTestReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","codeEditor","clickableCanvas","canvasTest","canvasTestReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const code_button = view(codeEditor("canvas:click-button", {
  value: `export function draw(state) {
  // Knopf zeichnen
  ctx.fillStyle = "#4f46e5"
  ctx.fillRect(150, 70, 200, 90)

  ctx.fillStyle = "white"
  ctx.font = "24px Arial"
  ctx.textAlign = "center"
  ctx.textBaseline = "middle"
  ctx.fillText("Klick mich!", 250, 115)

  // klickbaren Bereich auf dieselbe Stelle legen
  onClick(150, 70, 200, 90, () => {
console.log("Der Knopf wurde geklickt! 🎉")
  })
}`
}));
return {code_button};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_button"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: (display,clickableCanvas,code_button) => {
display(clickableCanvas(code_button, { width: 500, height: 230 }));
},
    inputs: ["display","clickableCanvas","code_button"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (view,codeEditor) => {
const code_grow = view(codeEditor("canvas:click-grow", {
  value: 'export function draw(state) {\n  // Hintergrund\n  ctx.fillStyle = "white"\n  ctx.fillRect(0, 0, canvas.width, canvas.height)\n\n  // ein Quadrat in der aktuellen Größe (zentriert)\n  ctx.fillStyle = "#16a34a"\n  ctx.fillRect(150 - state.größe / 2, 110 - state.größe / 2, state.größe, state.größe)\n\n  // Knopf\n  ctx.fillStyle = "#4f46e5"\n  ctx.fillRect(90, 190, 120, 40)\n  ctx.fillStyle = "white"\n  ctx.font = "20px Arial"\n  ctx.textAlign = "center"\n  ctx.textBaseline = "middle"\n  ctx.fillText("Größer!", 150, 210)\n\n  onClick(90, 190, 120, 40, () => {\n    makeBigger()\n  })\n}'
}));
return {code_grow};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_grow"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-10`),
    expanded: [],
    variables: []
  },
  {
    id: 10,
    body: (display,clickableCanvas,code_grow) => {
display(clickableCanvas(code_grow, {
  width: 300, height: 240,
  initialState: { größe: 40 },
  moves: {
    makeBigger: (state) => { state.größe = state.größe + 20 }
  }
}));
},
    inputs: ["display","clickableCanvas","code_grow"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (view,codeEditor) => {
const code_multi = view(codeEditor("canvas:click-multi", {
  value: 'export function draw(state) {\n  // Hintergrund\n  ctx.fillStyle = "white"\n  ctx.fillRect(0, 0, canvas.width, canvas.height)\n\n  // großes Quadrat in der aktuellen Farbe\n  ctx.fillStyle = state.farbe\n  ctx.fillRect(260, 30, 180, 180)\n\n  // drei Farbknöpfe\n  const knöpfe = ["red", "green", "blue"]\n  let y = 30\n  for (const f of knöpfe) {\n    ctx.fillStyle = f\n    ctx.fillRect(30, y, 180, 50)\n    onClick(30, y, 180, 50, () => {\n      waehleFarbe(f)\n    })\n    y = y + 70\n  }\n}'
}));
return {code_multi};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_multi"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-13`),
    expanded: [],
    variables: []
  },
  {
    id: 13,
    body: (display,clickableCanvas,code_multi) => {
display(clickableCanvas(code_multi, {
  width: 470, height: 240,
  initialState: { farbe: "gray" },
  moves: {
    waehleFarbe: (state, farbe) => { state.farbe = farbe }
  }
}));
},
    inputs: ["display","clickableCanvas","code_multi"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (view,codeEditor) => {
const code_grid = view(codeEditor("canvas:click-grid", {
  value: 'const feld = 80\n\nexport function draw(state) {\n  ctx.fillStyle = "white"\n  ctx.fillRect(0, 0, canvas.width, canvas.height)\n  ctx.font = "48px Arial"\n  ctx.textAlign = "center"\n  ctx.textBaseline = "middle"\n\n  for (let zeile = 0; zeile < 3; zeile++) {\n    for (let spalte = 0; spalte < 3; spalte++) {\n      const x = spalte * feld\n      const y = zeile * feld\n\n      ctx.strokeStyle = "black"\n      ctx.lineWidth = 2\n      ctx.strokeRect(x, y, feld, feld)\n\n      const schlüssel = zeile + "," + spalte\n      if (state.markiert[schlüssel]) {\n        ctx.fillStyle = "#ef4444"\n        ctx.fillText("✗", x + feld / 2, y + feld / 2)\n      }\n\n      onClick(x, y, feld, feld, () => {\n        markiere(schlüssel)\n      })\n    }\n  }\n}'
}));
return {code_grid};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_grid"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: (display,clickableCanvas,code_grid) => {
display(clickableCanvas(code_grid, {
  width: 240, height: 240,
  initialState: { markiert: {} },
  moves: {
    markiere: (state, schlüssel) => { state.markiert[schlüssel] = true }
  }
}));
},
    inputs: ["display","clickableCanvas","code_grid"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: (view,codeEditor) => {
const code_ex1 = view(codeEditor("canvas:click-ex1", {
  value: `export function draw(state) {
  // 1. Hintergrund + Knopf zeichnen
  // 2. Zählerstand state.anzahl mit fillText anzeigen
  // 3. onClick(...) auf den Knopf legen, dessen handler hochzaehlen() aufruft
}`
}));
return {code_ex1};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex1"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: (display,clickableCanvas,code_ex1) => {
display(clickableCanvas(code_ex1, {
  width: 320, height: 240,
  initialState: { anzahl: 0 },
  moves: { hochzaehlen: (state) => { state.anzahl = state.anzahl + 1 } }
}));
},
    inputs: ["display","clickableCanvas","code_ex1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (display,canvasTestReport,canvasTest,code_ex1) => {
const lastNumber = (p) => {
  const nums = p.callsTo("fillText")
    .map(c => parseInt(String(c.args[0]).replace(/[^0-9]/g, ""), 10))
    .filter(n => !isNaN(n));
  return nums.length ? nums[nums.length - 1] : null;
};
display(canvasTestReport(canvasTest(code_ex1, {
  width: 320, height: 240,
  initialState: { anzahl: 0 },
  moves: { hochzaehlen: (state) => { state.anzahl = state.anzahl + 1 } },
  checks: [
    { name: "Ein klickbarer Bereich (`onClick`)", run: ({ base }) => {
        const n = base.clickHandlers.length;
        return { passed: n >= 1, detail: `${n} onClick-Bereich(e)` };
    } },
    { name: "Zählerstand wird angezeigt", run: ({ base }) => {
        return { passed: lastNumber(base) !== null, detail: lastNumber(base) === null ? "keine Zahl mit fillText gefunden" : `Start bei ${lastNumber(base)}` };
    } },
    { name: "Ein Klick erhöht den Zähler", run: ({ probe }) => {
        const p = probe();
        if (!p.clickHandlers.length) return { passed: false, detail: "kein onClick registriert" };
        const before = lastNumber(p);
        const h = p.clickHandlers[0];
        p.clickAt(h.x + h.width / 2, h.y + h.height / 2);
        const after = lastNumber(p);
        return { passed: before !== null && after !== null && after > before, detail: `vorher ${before}, nachher ${after}` };
    } }
  ]
}), "Übung 1"));
return {lastNumber};
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex1"],
    outputs: ["lastNumber"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: (view,codeEditor) => {
const code_ex2 = view(codeEditor("canvas:click-ex2", {
  value: `export function draw(state) {
  // Schalter je nach state.an in einer von zwei Farben zeichnen
  // onClick(...) legen, dessen handler umschalten() aufruft
}`
}));
return {code_ex2};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-24`),
    expanded: [],
    variables: []
  },
  {
    id: 24,
    body: (display,clickableCanvas,code_ex2) => {
display(clickableCanvas(code_ex2, {
  width: 320, height: 240,
  initialState: { an: false },
  moves: { umschalten: (state) => { state.an = !state.an } }
}));
},
    inputs: ["display","clickableCanvas","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: (display,canvasTestReport,canvasTest,code_ex2) => {
display(canvasTestReport(canvasTest(code_ex2, {
  width: 320, height: 240,
  initialState: { an: false },
  moves: { umschalten: (state) => { state.an = !state.an } },
  checks: [
    { name: "Ein klickbarer Bereich (`onClick`)", run: ({ base }) => {
        const n = base.clickHandlers.length;
        return { passed: n >= 1, detail: `${n} onClick-Bereich(e)` };
    } },
    { name: "Ein Klick ändert die Farbe", run: ({ probe }) => {
        const p = probe();
        if (!p.clickHandlers.length) return { passed: false, detail: "kein onClick registriert" };
        const h = p.clickHandlers[0];
        const sx = Math.round(h.x + 6), sy = Math.round(h.y + 6);
        const before = p.pixelNow(sx, sy);
        p.clickAt(h.x + h.width / 2, h.y + h.height / 2);
        const after = p.pixelNow(sx, sy);
        const diff = Math.abs(before[0] - after[0]) + Math.abs(before[1] - after[1]) + Math.abs(before[2] - after[2]);
        return { passed: diff > 40, detail: diff > 40 ? "Farbe ändert sich" : "keine Farbänderung erkannt" };
    } },
    { name: "Zweiter Klick schaltet zurück", run: ({ probe }) => {
        const p = probe();
        if (!p.clickHandlers.length) return { passed: false, detail: "kein onClick registriert" };
        const h = p.clickHandlers[0];
        const sx = Math.round(h.x + 6), sy = Math.round(h.y + 6);
        const start = p.pixelNow(sx, sy);
        p.clickAt(h.x + h.width / 2, h.y + h.height / 2);
        p.clickAt(h.x + h.width / 2, h.y + h.height / 2);
        const back = p.pixelNow(sx, sy);
        const diff = Math.abs(start[0] - back[0]) + Math.abs(start[1] - back[1]) + Math.abs(start[2] - back[2]);
        return { passed: diff < 30, detail: diff < 30 ? "zurück im Ausgangszustand" : "nicht zum Start zurückgekehrt" };
    } }
  ]
}), "Übung 2"));
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
